module.exports = __webpack_public_path__ + "img/logo_large.017577a0.png";